import migration from '../assets/migration-3129340_1280.jpg'
import facebook from '../assets/facebook_5968764.png'
import instagram from '../assets/instagram_2111463.png'
import gmail from '../assets/gmail_5968534.png'
import twitter from '../assets/twitter-x-e1690183153269-removebg-preview.png'
import phone from '../assets/phone.png'
import { Link } from 'react-router-dom'
import { ABOUT, CONTACT, EVENT, HOME, TEAM } from '../constants/constants'
import { sendEmail } from '../services/email.service'

const FooterComponent = () => {


    const onSubmit = e => {
        // e.preventDefault()
        console.log(e)
        const formData = new FormData(e.target)
        const to = formData.get('email')
        console.log(to)
        sendEmail(to, `Subscribe to news letters`, `this user want to subscribe to our news letters (any update).`, ``, ``)
    }


    return (
        <>
            <section
                style={{
                    background: `linear-gradient(rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 0.8)) , url(${migration})`,
                    backgroundSize: 'cover',
                    backgroundAttachment: 'fixed'
                }}
                className={`Lg:h-[470px] md:h-[500px] sm:h-auto w-[100%] px-4 py-3.5 bg-cover bg-no-repeat bg-center bg-blend-normal text-white`}>


                <div className='px-4 py-2'>

                    <div className='grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-1 gap-[2.5rem] py-6'>

                        <div className=' px-2 py-3'>
                            <h1 className='text-[26px] font-bold py-2'>bulletins d'information</h1>
                            <p className='text-justify text-[15px] py-4'>
                                Recevez les dernières actualités, offres spéciales et mises à jour directement dans votre boîte de réception.
                                Nous respectons votre vie privée. Consultez notre
                            </p>
                            {/* <p> <a href="/votre-politique-de-confidentialite">politique de confidentialité</a>.</p> */}

                            <div className='my-4 py-4'>
                                <form method='GET' onSubmit={onSubmit} className='w-[320px] bg-none border-2 border-white px-0.5 py-1 rounded-md'>
                                    <input
                                        className='bg-transparent px-2 py-2 outline-none w-[70%] '
                                        type='email'
                                        required
                                        name='email'
                                        placeholder='Enter your email' />
                                    <button
                                        className='px-3 py-3 bg-[#FFA809] font-bold text-[13px] rounded-[4px] lg:w-[30%]'
                                        type='submit'>
                                        Subscribe
                                    </button>
                                </form>
                            </div>

                        </div>

                        <div className='px-2 py-3'>
                            <h1 className='text-[26px] font-bold py-2'>Lien de Navigation</h1>

                            <div className=''>
                                <Link to={`/${EVENT}/`} className='py-2 block'>Nos Evenements</Link>
                                <Link to={`/${TEAM}/`} className='py-2 block'>Notre Equipe</Link>
                                <Link to={`/${ABOUT}/`} className='py-2 block'>A propos de nous</Link>
                                <Link to={`/${HOME}/`} className='py-2 block'>Acceuil</Link>
                                <Link to={`/${CONTACT}/`} className='py-2 block'>Nous Contact</Link>
                            </div>
                        </div>

                        <div className='px-2 py-3 '>
                            <h1 className='text-[26px] font-bold py-2'>Contactez nous</h1>
                            <div className='flex justify-start align-middle gap-4 px-2 py-4'>
                                <a href='https://www.facebook.com/Onfejhaiti/' target='_blank' >
                                    <img
                                        src={`${facebook}`}
                                        alt='facebook'
                                        className='h-[25px] w-[25px] object-cover'
                                    />
                                </a>

                                <a href='https://www.instagram.com/onfejhaiti/' target='_blank'>
                                    <img
                                        src={`${instagram}`}
                                        alt='instagram'
                                        className='h-[25px] w-[25px] object-cover'

                                    />
                                </a>

                                <a href='https://twitter.com/onfejhaiti' target='_blank'>
                                    <img

                                        src={`${twitter}`}
                                        alt='twitter'
                                        className='h-[25px] w-[25px] object-cover'
                                    />
                                </a>

                                <Link to='mailto:contactonfej@gmail.com?subject=subject&body=body&email=contactonfej@gmail.com' >
                                    <img
                                        src={`${gmail}`}
                                        alt='gmail'
                                        className='h-[25px] w-[25px] object-cover'
                                    />
                                </Link>


                            </div>
                            <div className='flex justify-start align-middle gap-2 px-2 py-2'>
                                <img
                                    src={`${phone}`}
                                    alt='phones'
                                    className='h-[25px] w-[25px] object-cover'

                                />
                                <small className='text-[17px]'>
                                    (509) 3873-3954 / 3110-6699
                                </small>
                            </div>
                        </div>


                    </div>


                    <div className='text-center  my-6 px-2'>
                        <div className='w-[50%] m-auto h-[2px] bg-white'></div>
                        <div className='px-2 py-3'>
                            All right reserved &copy;Made by CodeCraft <a href='contactus' target='_blank'>Contact</a>
                        </div>
                    </div>
                </div>


            </section>
        </>
    )
}

export default FooterComponent